/**
 * 定数宣言
 */

export type DBType = 'sqlite' | 'mysql' | 'postgres';
